<template>
  <facet-list-fi
    ref="facet"
    :name="facet.name"
    :elements="elements"
    :unit="facet.unit"
    class="fact-finder-text-facet"
    @close="$emit('close')"
    @change="change"
    @clear-selection="clearSelection"
  />
</template>

<script setup lang="ts">
import { FacetListFi } from 'atoms';
import { computed, useTemplateRef } from 'vue';

defineOptions({ name: 'FactFinderTextFacet' });

const props = withDefaults(
  defineProps<{
    facet?: Record<string, any>;
    unselectedFacet?: Record<string, any> | null;
  }>(),
  {
    facet: () => ({}),
    unselectedFacet: null,
  },
);

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'change', payload: any): void;
}>();

const facetRef = useTemplateRef<{ close: () => void }>('facet');

function isChecked(element: any) {
  if (element.selectedBool) {
    return true;
  }
  if (props.unselectedFacet) {
    const elementInActualFacet = props.facet.elements.find(
      (actualElement: any) => actualElement.text === element.text,
    );
    return elementInActualFacet?.selectedBool;
  }

  return false;
}

const elements = computed(() => {
  const { elements: els } = props.unselectedFacet || props.facet;
  return els.map((element: any) => ({
    name: element.text,
    key: `${element.text}${props.unselectedFacet ? '_r' : ''}`,
    associatedFieldName: props.facet.associatedFieldName,
    selected: isChecked(element),
    count: element.totalHits,
    disabled: element.disabled, // TODO
  }));
});

function close() {
  if (facetRef.value) {
    facetRef.value.close();
  } else {
    emit('close');
  }
}

function clearSelection() {
  props.facet.elements.forEach((element: any) => {
    emit('change', {
      value: false,
      element: {
        ...element,
        selected: false,
      },
    });
  });
  close();
}

function change({ value, element }: any) {
  emit('change', {
    value,
    element: {
      associatedFieldName: element.associatedFieldName,
      name: element.name,
      selected: value,
    },
  });
  close();
}

defineExpose({ close });
</script>

<style scoped src="./fact-finder-text-facet" />
